<app-breadcrumb [breadcrumbs]="breadcrumbs$ | async"></app-breadcrumb>

@if (loading) {
    <ngx-skeleton-loader count="5" appearance="line" [theme]="{height: '64px'}" />
}

@if (!loading && state) {
<div class="gp-layout-page">
    <div class="edit-ad-header">
        <div class="header-row-1">
            eBuilder
            <span class="header-dot"></span>
            {{ state.advertiserName }}
        </div>
        <div class="header-row-2">
            {{ state.campaignName }}
        </div>
    </div>

    <div class="gp-body">
        <div class="gp-panel">
            <div class="gp-step-label">Step 1 of 2</div>
            <h1>How Many Products Would You Like to Feature?</h1>
            <p>Select the number of products you would like to showcase in your Game Plan listing. Your selection determines how much space is available for product descriptions and content.</p>

            <div class="gp-cards">
                @for (count of cards; track count) {
                <label
                    class="gp-card"
                    [class.selected]="selectedCount === count"
                    (click)="onCardClick(count)"
                >
                    <div class="gp-card__indicator">
                        @if (selectedCount === count) {
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path d="M2 6l3 3 5-5" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        }
                    </div>
                    <div class="gp-card__heading">
                        <span class="gp-card__number">{{ count }}</span>
                        <span class="gp-card__unit">{{ count === 1 ? 'Product' : 'Products' }}</span>
                    </div>
                    <div class="gp-graphic">
                        <div class="gp-graphic__inner">
                            <div class="gp-graphic__logo"></div>
                            <div class="gp-graphic__products">
                                @for (slot of productSlots(count); track $index) {
                                <div class="gp-graphic__product">
                                    <div class="gp-graphic__product-name"></div>
                                    <div class="gp-graphic__product-desc"></div>
                                </div>
                                }
                                @if (count === 3) {
                                <div class="gp-graphic__slot-empty"></div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="gp-card__desc">{{ cardDescs[count] }}</div>
                </label>
                }
            </div>

            @if (selectedCount !== null) {
            <div class="gp-info-box">
                <div class="gp-info-icon">i</div>
                <div>
                    <div class="gp-info-title">{{ cardInfo[selectedCount].title }}</div>
                    <div class="gp-info-text">{{ cardInfo[selectedCount].desc }}</div>
                </div>
            </div>
            }

            <hr class="gp-divider">

            <div class="gp-actions">
                <button
                    type="button"
                    class="gp-continue-btn"
                    [disabled]="selectedCount === null || saving"
                    (click)="onContinue()"
                >
                    {{ saving ? 'Saving...' : 'Continue' }}
                    @if (!saving) {
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    }
                </button>
            </div>
        </div>
    </div>
</div>

@if (showModal) {
<div class="gp-modal-overlay" (click)="onModalCancel()">
    <div class="gp-modal" (click)="$event.stopPropagation()">
        <h2>Changing Product Count May Impact Existing Content</h2>
        <p>Changing the number of products you feature will adjust the available space and layout of your listing. Existing content and formatting may be disrupted, shortened, or require editing before publication.</p>
        <p class="gp-modal-question">Would you like to continue?</p>
        <div class="gp-modal-actions">
            <button type="button" class="gp-modal-cancel" (click)="onModalCancel()">Cancel</button>
            <button type="button" class="gp-modal-confirm" (click)="onModalConfirm()">Continue &amp; Update Layout</button>
        </div>
    </div>
</div>
}
}
